module.exports = __webpack_public_path__ + "static/media/Item_Head_E_00_Lv1_C.1f6528e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Equipment/Headgear/Item_Head_E_00_Lv1_C.png
// module id = 195
// module chunks = 0